import VehicleBuildabilityStatus from './VehicleBuildabilityStatus'

export default VehicleBuildabilityStatus